<template>
  <div>
    <div :class="stepClass">
      <custom-input
        stop-clearfix
        :label-as-a-container="false"
        :label="$t('business_listing.stepper.payment')"
        :error-text="errorGenerator($v.value.paymentMethods)"
      >
        <multiselect
          v-model="value.paymentMethods"
          :options="allowedPaymentMethods"
          :multiple="true"
          :close-on-select="false"
          :deselect-label="$t('business_listing.stepper.rm_pay_method')"
          :select-label="$t('business_listing.stepper.add_pay_method')"
          :placeholder="$t('business_listing.stepper.pay_method_placeholder')"
          track-by="code"
          hide-selected
          label="name"
        />
      </custom-input>
      <custom-input
        stop-clearfix
        :label-as-a-container="false"
        label="Keywords"
        :error-text="errorGenerator($v.value.keywords)"
      >
        <multiselect
          v-model="value.keywords"
          :options="value.keywords"
          :multiple="true"
          :taggable="true"
          :deselect-label="$t('business_listing.stepper.rm_keyword')"
          :close-on-select="false"
          :tag-placeholder="$t('business_listing.stepper.add_keyword')"
          hide-selected
          :placeholder="$t('business_listing.stepper.keyword_placeholder')"
          @tag="addKeyword"
        />
      </custom-input>
    </div>
    <ButtonGroup
      :show-prev-btn="!isOuterStep.first"
      :show-finish-btn="isOuterStep.last"
      @click.native="step"
    />
  </div>
</template>

<script>
// import { required, minLength } from 'vuelidate/lib/validators'
import CustomInput from '@/components/Shared/CustomInput'
import Multiselect from 'vue-multiselect'
import formHelperMixin from '@/mixins/form-helper'
import ButtonGroup from './ButtonGroup'
export default {

  name: 'StepPayment',
  components: {
    Multiselect,
    CustomInput,
    ButtonGroup
  },
  mixins: [formHelperMixin],
  props: {
    // class can't be used as a prop name, so to pass any custom classes as a
    // prop, we need to pass them in as 'stepClass'
    stepClass: {
      type: String,
      default: ''
    },
    // Check if this step is the first or last and therefore decide whether to
    // show or hide the next/prev buttons
    isOuterStep: {
      type: Object,
      default: () => ({ first: true, last: false })
    },
    // The value should be passed in as a prop, and we can use the v-model
    // directive to bind to the specific part of the passed value relevant
    // for this step
    value: {
      type: Object,
      default: () => ({
        keywords: [],
        paymentMethods: []
      })
    }
  },
  validations: {
    value: {
      paymentMethods: {},
      keywords: {}
    }
  },
  computed: {
    allowedPaymentMethods () {
      return [
        { name: this.$t('business_listing.stepper.visa'), code: 'visa' },
        { name: this.$t('business_listing.stepper.mastercard'), code: 'mastercard' },
        { name: this.$t('business_listing.stepper.amex'), code: 'amex' },
        { name: this.$t('business_listing.stepper.cash'), code: 'cash' },
        { name: this.$t('business_listing.stepper.paypal'), code: 'paypal' },
        { name: this.$t('business_listing.stepper.cheque'), code: 'cheque' },
        { name: this.$t('business_listing.stepper.applepay'), code: 'applepay' },
        { name: this.$t('business_listing.stepper.androidpay'), code: 'androidpay' },
        { name: this.$t('business_listing.stepper.contactless'), code: 'contactless' },
        { name: this.$t('business_listing.stepper.bank_transfer'), code: 'bankTransfer' }
      ]
    }
  },

  methods: {
    step ({ target }) {
      if (target.id === 'next-btn') {
        this.$emit('next', this.$v)
      } else if (target.id === 'prev-btn') {
        this.$emit('prev')
      }
    },
    addKeyword (newTag) {
      this.value.keywords.push(newTag)
    }
  }
}
</script>

<style lang="css">
.multiselect__content-wrapper {
  /*background-color: blue !important;*/
  /*padding:0 !important;*/
  /*max-height: 3px !important;*/
}
.multiselect__content-wrapper .multiselect__content {
 /* background-color: blue !important;
  padding:0 !important;*/
  /*max-height: 3px !important;*/
  /*background-color: green !important;*/
  /*height: 5px;*/
}
</style>
